import module from './me.module';
import './me.controller';

export default module.name;